import React from "react";
import { Cta } from "../components/site/kit";

export default function NotFound() {
  return (
    <div className="font-body flex min-h-screen flex-col items-start justify-center bg-black px-6 pt-24 text-white md:px-12 lg:px-16">
      <p className="font-body text-sm font-semibold uppercase tracking-[0.2em] text-[#5f8f10]">Error 404</p>
      <h1 className="font-display mt-6 text-7xl leading-[0.9] tracking-tight md:text-9xl">
        Page<br />not <span className="text-[#5f8f10]">found.</span>
      </h1>
      <p className="font-body mt-8 max-w-md text-xl font-normal leading-relaxed text-white/85">
        The page you were looking for isn&rsquo;t here, but your growth problem still is.
      </p>
      <div className="mt-10 flex flex-wrap gap-5">
        <Cta primary to="/" testId="notfound-home-cta">Back to Home</Cta>
        <Cta dark to="/find-your-switch" testId="notfound-fys-cta">Find Your Switch</Cta>
      </div>
    </div>
  );
}
